import React, { Component } from "react";
import { dateFormaterSpecific } from "../../assets/Js/DateFormater";
import { chatGroupEnum } from "../../assets/Js/chatGroupEnum";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";

export default class ChatCard extends Component {
  constructor(props) {
    super(props);
  }

  handleClick = (item) => {
    const groupId = this.props.userCard ? null : item.UserId;

    this.props.handleClick({
      userId: item.UserId,
      groupId: groupId,
      UserName: item.UserName,
      image: item.Image,
      isGroup: item.IsGroup,
      index: this.props.index,
      groupType: item.GroupType,
    });
    return;
  };

  showProfile = (Image) => {
    let isGroup = this.props.item.GroupType !== chatGroupEnum.OneToOne;

    return (
      <DisplayPicture
        className="profileImageBig"
        image={Image}
        showGroupAvatar={isGroup}
      />
    );
  };

  render() {
    const { UserId, Image, UserName, UnReads, Date, Message, GroupType } =
    this.props.item;

    return (
      <li
        className={`
            contact mt-1 chatCardContainer  ${
              this.props.listOverLayIndex === UserId && "listOverLayIndex"
            }
            ${this.props.userCard && "text-primary"}
            `}
        onClick={() => {
          this.handleClick(this.props.item);
        }}
      >
        <div className="d-flex wrap ml-2">
          <div className="d-flex align-items-center flex-row chatCardImage">
            <div>{this.showProfile(Image)}</div>
            <div className="meta w-100">
              <div className="d-flex name justify-content-between w-100">
                <p>
                  {UserName.length > (this.props.textLimit || 12)
                    ? UserName.slice(0, this.props.textLimit || 12) + ".."
                    : UserName}
                </p>
                {(GroupType === chatGroupEnum.TrackGroup ||
                  GroupType === chatGroupEnum.GymGroup ||
                  GroupType === chatGroupEnum.CustomGroup) && (
                  <p
                    className={`ml-3 chip ${
                      (GroupType === chatGroupEnum.GymGroup && "gymGroup") ||
                      (GroupType === chatGroupEnum.TrackGroup &&
                        "trackGroup") ||
                      (GroupType === chatGroupEnum.CustomGroup && "customGroup")
                    }`}
                  >
                    {GroupType === chatGroupEnum.TrackGroup && "Track"}
                    {GroupType === chatGroupEnum.GymGroup && "Gym"}
                    {GroupType === chatGroupEnum.CustomGroup && "Group"}
                  </p>
                )}
              </div>
              <p className="preview">
                {Message && Message.length >= 15
                  ? Message.slice(0, 15) + "..."
                  : Message}
              </p>
            </div>
          </div>
          {!this.props.userCard && (
            <div className="">
              <p className="chatCardDateDesign mt-1">
                {Message && this.props && dateFormaterSpecific(Date)}
              </p>
              {this.props && UnReads > 0 && (
                <div className="unread text-center colorWhite ml-2">
                  {UnReads}
                </div>
              )}
            </div>
          )}
        </div>
      </li>
    );
  }
}
